import { Tabs } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { cn } from "../../../../utils/cn.ts"
import {
  PROJECT_QUICK_VIEWS,
  type ProjectQuickView
} from "../../helpers/projects-url-state.ts"
import type { ProjectQuickViewCounts } from "../../redux/projects.types.ts"

// The mockup counts the first four; On hold and Closed are reached for, not watched.
const COUNTED: ProjectQuickView[] = [
  "all",
  "active",
  "attention",
  "closing_soon"
]

interface ProjectQuickViewsProps {
  value: ProjectQuickView
  counts: ProjectQuickViewCounts | null
  /** Closed lists the Archive's rows, so it needs the archive right. */
  closedAllowed: boolean
  onChange: (view: ProjectQuickView) => void
}

export function ProjectQuickViews({
  value,
  counts,
  closedAllowed,
  onChange
}: ProjectQuickViewsProps) {
  const { t } = useTranslation()

  const views = PROJECT_QUICK_VIEWS.filter(
    (view) => view !== "closed" || closedAllowed
  )

  return (
    <Tabs
      activeKey={value}
      onChange={(key) => onChange(key as ProjectQuickView)}
      className="[&_.ant-tabs-nav]:mb-0"
      items={views.map((view) => {
        const count = counts?.[view]
        const showCount = COUNTED.includes(view) && typeof count === "number"
        return {
          key: view,
          label: (
            <span className="inline-flex items-center gap-2">
              {t(`projectsCommand.quickViews.${view}`)}
              {showCount ? (
                <span
                  className={cn(
                    // The active tab paints its label as gradient text
                    // (transparent fill); the count keeps a solid fill.
                    "rounded-full px-2 text-xs font-medium leading-5 tabular-nums [-webkit-text-fill-color:currentColor]",
                    view === "attention" && count
                      ? "bg-amber-100 text-amber-900"
                      : "bg-slate-100 text-slate-700"
                  )}
                >
                  {count}
                </span>
              ) : null}
            </span>
          )
        }
      })}
    />
  )
}
